import { Card, EventHandler, Tooltip } from "client/CommonComponents";
import Moment from "moment";
import comment from "../../assets/images/Comments.png";
import "./ApprovalHistoryTimeLineCommon.scss";
import { getNumberText } from "client/utils/constants";

const ApproverHistoryTimelineCommon = (props: any) => {
  const approvalHistory = props.approvalHistory;
  const isOrderDetail = props?.isOrderDetail;
  const onCollapse = props.onCollapse;
  const collapse = props.collapse;
  const content = "Tooltip Data";

  return (
    <>
      <div className="approvalHistoryTimeline">
        <div className="list-block-container">
          <div className="header-approval">
            <p className="blueLabel mb-0 approvalHeading mt-0">APPROVAL HISTORY TIMELINE</p>
            {isOrderDetail ? (
              <p className={`item-category mt-1 ${"approval-process"}`}>
                <EventHandler onEvent={() => onCollapse()} data-attribute="ApprovalHistoryTimeLineCommon_Default_EventHandler">
                  <span
                    className="fa fa-angle-down mx-2"
                  ></span>
                </EventHandler>
                <span className="align">Approval Process</span>
              </p>
            ) : null}
          </div>
          {collapse
            ? approvalHistory?.map((attempt: any, i: any) => (
              <>
                <Card data-attribute="ApprovalHistoryTimeLineCommon_Default_Card">
                  <div key={i} className={`approvalAttempt ${isOrderDetail ? "approvalProcessAccordion" : "mt-4"}`}>
                    {approvalHistory.length > 1 && (
                      <p className="blueLabel mb-3">
                        APPROVAL HISTORY TIMELINE - {getNumberText(attempt?.attemptNo)?.toUpperCase()} ATTEMPT
                      </p>
                    )}
                    {attempt.approvalList?.map((item: any, j: any) => {
                      const tooltipProps = {
                        onRenderContent: () => (
                          <div>
                            <p className="Heading">
                              Ranking {item.stepNumber} has been approved
                            </p>
                            <div className="detail-comment-block">
                              <ul className="mb-0">
                                {item?.approvalHistoryComments?.length <= 0 ? (
                                  <div className="comment-text mt-2">{"-"}</div>
                                ) : (
                                  item?.approvalHistoryComments?.map(
                                    (comment: any, index: any) =>
                                      comment?.comments ? (
                                        <div
                                          className="comment-text mt-2"
                                          key={index}
                                        >
                                          {comment?.comments}
                                        </div>
                                      ) : null
                                  )
                                )}
                              </ul>
                            </div>
                          </div>
                        ),
                      };
                      return (
                        <div className={`approvalBlock ${item.status}`} key={j}>
                          <div className="approved-by-block">
                            <p className="label">Name</p>
                            <Tooltip
                              content={item.approvedBy ? item.approvedBy : "-"}
                             data-attribute="ApprovalHistoryTimeLineCommon_Default_Tooltip">
                              <p className="approved-by">
                                {item.approvedBy ? item.approvedBy : "-"}
                              </p>
                            </Tooltip>
                          </div>
                          <div className="approved-date-block">
                            <p className="label">Date</p>
                            <p>
                              {item.approvedDate
                                ? Moment(item.approvedDate).format("MM/DD/YYYY")
                                : "-"}
                            </p>
                          </div>
                          <div className="approved-status-block">
                            <p className="label">Status</p>
                            <p className="approved-block-status">
                              {item.status}
                            </p>
                          </div>
                          {(item?.status?.includes("Approved") ||
                            item?.status?.includes("Rejected") ||
                            item?.status?.includes("Returned") ||
                            item?.status?.includes("Denied")) && (
                              <Tooltip tooltipProps={tooltipProps} data-attribute="ApprovalHistoryTimeLineCommon_Default_Tooltip_2">
                                <div className="commentBlock">
                                  <img
                                    src={comment}
                                    alt="comment"
                                    className="comments"
                                  />
                                </div>
                              </Tooltip>
                            )}
                        </div>
                      );
                    })}
                    {attempt?.additionalApprovalList?.length > 0 && (
                      <p className="blueLabel additionalApprovalTitle mb-3">
                        ADDITIONAL APPROVAL HISTORY TIMELINE
                      </p>
                    )}
                    {attempt?.additionalApprovalList?.map((item: any, j: any) => {
                      const tooltipProps = {
                        onRenderContent: () => (
                          <div>
                            <p className="Heading">
                              Ranking {item.stepNumber} has been approved
                            </p>
                            <div className="detail-comment-block">
                              <ul className="mb-0">
                                {item?.approvalHistoryComments?.length <= 0 ? (
                                  <div className="comment-text mt-2">{"-"}</div>
                                ) : (
                                  item?.approvalHistoryComments?.map(
                                    (comment: any, index: any) =>
                                      comment?.comments ? (
                                        <div
                                          className="comment-text mt-2"
                                          key={index}
                                        >
                                          {comment?.comments}
                                        </div>
                                      ) : null
                                  )
                                )}
                              </ul>
                            </div>
                          </div>
                        ),
                      };
                      return (
                        <div className={`approvalBlock ${item.status} ${attempt?.additionalApprovalList?.length > 0 ? 'additionalApproval' : ''}`} key={j}>
                          <div className="approved-by-block">
                            <p className="label">Name</p>
                            <Tooltip
                              content={item.approvedBy ? item.approvedBy : "-"}
                             data-attribute="ApprovalHistoryTimeLineCommon_Default_Tooltip_3">
                              <p className="approved-by">
                                {item.approvedBy ? item.approvedBy : "-"}
                              </p>
                            </Tooltip>
                          </div>
                          <div className="approved-date-block">
                            <p className="label">Date</p>
                            <p>
                              {item.approvedDate
                                ? Moment(item.approvedDate).format("MM/DD/YYYY")
                                : "-"}
                            </p>
                          </div>
                          <div className="approved-status-block">
                            <p className="label">Status</p>
                            <p className="approved-block-status">
                              {item.status}
                            </p>
                          </div>
                          {(item?.status?.includes("Approved") ||
                            item?.status?.includes("Rejected") ||
                            item?.status?.includes("Returned") ||
                            item?.status?.includes("Denied")) && (
                              <Tooltip tooltipProps={tooltipProps} data-attribute="ApprovalHistoryTimeLineCommon_Default_Tooltip_4">
                                <div className="commentBlock">
                                  <img
                                    src={comment}
                                    alt="comment"
                                    className="comments"
                                  />
                                </div>
                              </Tooltip>
                            )}
                        </div>
                      );
                    })}
                  </div>
                </Card>
              </>
            ))
            : null}
        </div>
      </div>
    </>
  );
};

export default ApproverHistoryTimelineCommon;
